import NetworkSpeed from 'network-speed' // ES5

async function getNetworkDownloadSpeed(): Promise<string> {
  const testNetworkSpeed = new NetworkSpeed()
  const baseUrl = `/-/media/Default Website/1px.ashx`
  const fileSizeInBytes = 119719
  const speed = await testNetworkSpeed.checkDownloadSpeed(
    baseUrl,
    fileSizeInBytes
  )

  if (speed.mbps === 'Infinity') return '100'
  return speed.mbps
}

export default getNetworkDownloadSpeed
